// @flow
let returnApiUrl = process.env.ZOOM_API_URL;
let returnClientIntegration = process.env.CLIENT_INTEGRATION_API_URL;
let returnZoomWmsBaseUrl = process.env.ZOOM_WMS_BASE_URL;

if (
  window &&
  window.location &&
  window.location.href &&
  window.location.href.includes('zoom-kubernetes-public.stg.rivigo.com') &&
  process.env.ZOOM_PUBLIC_API_URL
) {
  returnApiUrl = process.env.ZOOM_PUBLIC_API_URL;
  if (returnClientIntegration) {
    returnClientIntegration = returnClientIntegration.replace(
      'zoom-kubernetes',
      'zoom-kubernetes-public'
    );
  }
  if (returnZoomWmsBaseUrl) {
    returnZoomWmsBaseUrl = returnZoomWmsBaseUrl.replace(
      'zoom-kubernetes',
      'zoom-kubernetes-public'
    );
  }
}

const config = {
  name: process.env.NAME,
  baseName: process.env.BASE_NAME || '',
  oldDomainUrl: process.env.OLD_DOMAIN_URL,
  oldReactDomainUrl: process.env.OLD_REACT_DOMAIN_URL,
  zoomApiUrl: returnApiUrl,
  clientIntegrationApiUrl: returnClientIntegration,
  loginUrl: process.env.LOGIN_URL,
  login: process.env.LOGIN,
  logoutUrl: process.env.LOGOUT_URL,
  zoomCommunicationsEp: process.env.ZOOM_COMMUNICATIONS_EP,
  analyticsFlag: false || process.env.ANALYTICS_FLAG,
  analyticsId: process.env.ANALYTICS_ID,
  ga4AnalyticsId: process.env.GA4_ANALYTICS_ID,
  ticketingUrl: process.env.TICKETING_URL,
  zoomSuperSetUrl: process.env.ZOOM_SUPER_SET_URL,
  developerUrl: process.env.DEVELOPER_URL,
  zoomWmsBaseUrl: returnZoomWmsBaseUrl,
  vendorContractUrl: process.env.VENDOR_CONTRACT_URL,
  eRetailUrl: process.env.E_RETAIL_URL,
  crmOzoneTelCall: process.env.CRM_OZONE_TEL_CALL,
  crmGoogleForm: process.env.CRM_GOOGLE_FORM,
  mapBoxAccessToken: process.env.MAP_BOX_ACCESS_TOKEN,
  shipUrl: process.env.SHIP_URL,
  mllAirClientCode: process.env.MLL_AIR_CLIENT_CODE
};

export default config;
